/** Mentoring and course values are for the pricing UI and legacy Stripe metadata, not stripeCheckout. */
export enum ORDER_TYPE {
  DONATION = 'donation',
  COURSE = 'course',
  GROUP_MENTORING = 'group-mentoring',
  INDIVIDUAL_MENTORING = 'individual-mentoring',
  PROJECT_MENTORING = 'project-mentoring',
  NONE = 'none'
}
export enum DONATION_PURPOSE {
  VOLUNTEER_MENTORS = 'Mentorzy wolontariusze',
  KNOWLEDGE_DB = 'Baza wiedzy',
  STYPENDIUM = 'Stypendium',
  ANY = 'Dowolny'
}
